// =========================================================
// frontend/js/member.js - V10.6 (Self-Edit Permissions Fix)
// =========================================================

window.showToast = function(message, isError = false) {
    const toast = document.createElement('div');
    const bgColor = isError ? 'bg-rose-500' : 'bg-emerald-500';
    const icon = isError ? 'alert-octagon' : 'check-circle-2';
    
    toast.className = `fixed bottom-10 left-1/2 transform -translate-x-1/2 ${bgColor} text-white px-6 py-4 rounded-2xl shadow-2xl font-black text-sm tracking-wide flex items-center gap-3 z-[9999] transition-all duration-300 translate-y-10 opacity-0`;
    toast.innerHTML = `<i data-lucide="${icon}" class="w-5 h-5"></i> ${message}`;
    
    document.body.appendChild(toast);
    if (window.lucide) lucide.createIcons();

    setTimeout(() => {
        toast.classList.remove('translate-y-10', 'opacity-0');
        toast.classList.add('translate-y-0', 'opacity-100');
    }, 10);

    setTimeout(() => {
        toast.classList.remove('translate-y-0', 'opacity-100');
        toast.classList.add('translate-y-10', 'opacity-0');
        setTimeout(() => toast.remove(), 300);
    }, 3000);
};

window.openMemberModal = function(editUserId = null) {
    const u = window.currentUser;
    const isSelfEdit = editUserId === u?.uid;
    
    // FIX: Admins dürfen alles bearbeiten, normale User NUR ihr eigenes Profil
    const canManageUsers = ['OWNER', 'ADMIN', 'HR', 'SUPERADMIN'].includes(u?.role);

    if (!canManageUsers && !isSelfEdit) {
        window.showToast("Zugriff verweigert. Du darfst nur dein eigenes Profil bearbeiten.", true);
        return;
    }

    let existingUser = null;
    if (editUserId) {
        existingUser = (window.usersList || []).find(usr => usr.uid === editUserId);
        if (isSelfEdit) {
            existingUser = { ...existingUser, ...u };
        }
    }

    const isEditMode = !!existingUser;
    const isOwner = u?.role === 'OWNER';
    const availableRoles = Object.keys(window.activeRoles || {}).filter(role => isOwner || role !== 'OWNER');

    function flattenTree(nodes, depth = 0, result = []) {
        nodes.forEach(n => {
            result.push({ id: n.id, name: '\u00A0\u00A0'.repeat(depth) + (depth > 0 ? '↳ ' : '') + n.name });
            if (n.children && n.children.length > 0) flattenTree(n.children, depth + 1, result);
        });
        return result;
    }
    const flatTree = flattenTree(window.orgStructure || []);

    const street = existingUser?.address?.street || existingUser?.street || '';
    const houseNumber = existingUser?.address?.houseNumber || existingUser?.address?.hausnummer || existingUser?.houseNumber || existingUser?.hausnummer || '';
    const zip = existingUser?.address?.zip || existingUser?.address?.plz || existingUser?.zip || existingUser?.plz || '';
    const city = existingUser?.address?.city || existingUser?.city || '';

    const commute = existingUser?.commute || {};
    const userEvents = (window.events || []).filter(e => e.userId === editUserId && (e.type === 'HO' || e.type === 'homeoffice') && e.status === 'APPROVED');
    let totalSavedCO2 = 0;
    userEvents.forEach(e => {
        const impact = window.calculateImpact(commute, 1, e.co2SavedAtBooking);
        totalSavedCO2 += impact.co2Netto;
    });

    const modalHTML = `
        <div id="member-modal" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[200] flex items-center justify-center p-4 animate-fadeIn">
            <div class="bg-white rounded-[2.5rem] shadow-2xl w-full max-w-3xl flex flex-col max-h-[95vh] overflow-hidden">
                
                <div class="p-6 md:p-8 pb-4 border-b border-slate-100 flex items-center justify-between shrink-0 bg-blue-50/30">
                    <div class="flex items-center gap-4">
                        <div class="w-12 h-12 ${isEditMode ? 'bg-emerald-100 text-emerald-600' : 'bg-blue-100 text-blue-600'} rounded-2xl flex items-center justify-center">
                            <i data-lucide="${isEditMode ? 'user-cog' : 'user-plus'}" class="w-6 h-6"></i>
                        </div>
                        <div>
                            <h3 class="text-xl font-black text-slate-800 tracking-tight">${isEditMode ? 'Profil bearbeiten' : 'Neuen Mitarbeiter anlegen'}</h3>
                            <p class="text-emerald-600 text-[10px] font-black uppercase tracking-widest mt-1">
                                ${isEditMode ? `Bisher gespart: ${totalSavedCO2.toFixed(1)} kg CO₂` : 'Account erstellen'}
                            </p>
                        </div>
                    </div>
                    <button onclick="document.getElementById('member-modal').remove()" class="w-8 h-8 flex items-center justify-center bg-slate-100 text-slate-400 rounded-full hover:bg-slate-200 hover:text-slate-800 transition-all">
                        <i data-lucide="x" class="w-4 h-4"></i>
                    </button>
                </div>

                <div class="p-6 md:p-8 overflow-y-auto space-y-8 flex-1 bg-slate-50/30">
                    
                    <div>
                        <h4 class="text-xs font-black text-slate-400 uppercase tracking-widest mb-4 flex items-center gap-2"><i data-lucide="user" class="w-4 h-4"></i> Persönliche Daten</h4>
                        <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                            <div class="md:col-span-1">
                                <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1">Anrede</label>
                                <select id="mem-salutation" class="w-full bg-white border border-slate-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-blue-500">
                                    <option value="Herr" ${existingUser?.salutation === 'Herr' ? 'selected' : ''}>Herr</option>
                                    <option value="Frau" ${existingUser?.salutation === 'Frau' ? 'selected' : ''}>Frau</option>
                                    <option value="Divers" ${existingUser?.salutation === 'Divers' ? 'selected' : ''}>Divers</option>
                                </select>
                            </div>
                            <div class="md:col-span-3 grid grid-cols-2 gap-4">
                                <div>
                                    <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1">Vorname *</label>
                                    <input type="text" id="mem-first" value="${existingUser?.firstName || ''}" class="w-full bg-white border border-slate-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-blue-500">
                                </div>
                                <div>
                                    <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1">Nachname *</label>
                                    <input type="text" id="mem-last" value="${existingUser?.lastName || ''}" class="w-full bg-white border border-slate-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-blue-500">
                                </div>
                            </div>
                        </div>
                    </div>

                    <details class="group bg-white border border-slate-200 rounded-[2rem] p-2" open>
                        <summary class="flex items-center justify-between p-4 cursor-pointer font-black text-slate-700 uppercase tracking-widest text-xs">
                            <span class="flex items-center gap-2"><i data-lucide="map-pin" class="w-4 h-4 text-slate-400"></i> Wohnsitz / Adresse</span>
                            <i data-lucide="chevron-down" class="w-4 h-4 text-slate-400 group-open:rotate-180 transition-transform"></i>
                        </summary>
                        <div class="p-4 pt-0 space-y-6">
                            <div class="space-y-4 pt-4 border-t border-slate-100">
                                <div class="grid grid-cols-3 gap-4">
                                    <div class="col-span-2">
                                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1">Straße</label>
                                        <input type="text" id="mem-street" value="${street}" class="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-blue-500">
                                    </div>
                                    <div>
                                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1">Hausnr.</label>
                                        <input type="text" id="mem-house" value="${houseNumber}" class="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-blue-500">
                                    </div>
                                </div>
                                <div class="grid grid-cols-4 gap-4">
                                    <div class="col-span-1">
                                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1">PLZ</label>
                                        <input type="text" id="mem-zip" value="${zip}" class="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-blue-500">
                                    </div>
                                    <div class="col-span-3">
                                        <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1">Ort</label>
                                        <input type="text" id="mem-city" value="${city}" class="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-blue-500">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </details>

                    <div class="p-5 bg-blue-50/50 rounded-[2rem] border border-blue-100">
                        <h4 class="text-xs font-black text-blue-800 uppercase tracking-widest mb-4 flex items-center gap-2"><i data-lucide="network" class="w-4 h-4"></i> Organisation</h4>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label class="block text-[10px] font-black text-blue-600/70 uppercase tracking-widest mb-2 ml-1">Stamm-Abteilung</label>
                                <select id="mem-nodeId" ${!canManageUsers ? 'disabled title="Nur durch HR änderbar" class="w-full bg-slate-100 border border-slate-200 text-slate-400 rounded-xl px-4 py-3 font-bold cursor-not-allowed"' : 'class="w-full bg-white border border-blue-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-blue-500 shadow-sm"'}>
                                    <option value="">-- Keine Zuordnung --</option>
                                    ${flatTree.map(n => `<option value="${n.id}" ${existingUser?.nodeId === n.id ? 'selected' : ''}>${n.name}</option>`).join('')}
                                </select>
                            </div>
                            <div>
                                <label class="block text-[10px] font-black text-blue-600/70 uppercase tracking-widest mb-2 ml-1">Direkter Vorgesetzter</label>
                                <select id="mem-reportsTo" ${!canManageUsers ? 'disabled title="Nur durch HR änderbar" class="w-full bg-slate-100 border border-slate-200 text-slate-400 rounded-xl px-4 py-3 font-bold cursor-not-allowed"' : 'class="w-full bg-white border border-blue-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-blue-500 shadow-sm"'}>
                                    <option value="">-- Keiner (Top-Level) --</option>
                                    ${(window.usersList || [])
                                        .filter(usr => usr.role === 'OWNER' || usr.role === 'MANAGER' || usr.role === 'HR')
                                        .map(m => `<option value="${m.uid}" ${existingUser?.reportsTo === m.uid ? 'selected' : ''}>${m.firstName} ${m.lastName}</option>`)
                                        .join('')}
                                </select>
                            </div>
                        </div>
                    </div>

                    <div>
                        <h4 class="text-xs font-black text-slate-400 uppercase tracking-widest mb-4 flex items-center gap-2"><i data-lucide="settings" class="w-4 h-4"></i> Account & System</h4>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1">E-Mail (Login) *</label>
                                <input type="email" id="mem-email" value="${existingUser?.email || ''}" ${isEditMode ? 'readonly title="E-Mail kann nur vom User selbst in den Einstellungen geändert werden"' : ''} class="w-full ${isEditMode ? 'bg-slate-100 cursor-not-allowed text-slate-400' : 'bg-white text-slate-700'} border border-slate-200 rounded-xl px-4 py-3 font-bold outline-none focus:border-blue-500">
                            </div>
                            
                            ${!isEditMode ? `
                            <div>
                                <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1">Start-Passwort *</label>
                                <input type="text" id="mem-password" class="w-full bg-white border border-slate-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-blue-500" placeholder="Mind. 6 Zeichen">
                            </div>
                            ` : ''}

                            <div>
                                <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-1">System-Rolle</label>
                                <select id="mem-role" ${!canManageUsers ? 'disabled title="Nur durch HR änderbar" class="w-full bg-slate-100 border border-slate-200 text-slate-400 rounded-xl px-4 py-3 font-bold cursor-not-allowed"' : 'class="w-full bg-white border border-slate-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-blue-500"'}>
                                    ${availableRoles.map(r => `<option value="${r}" ${existingUser?.role === r ? 'selected' : ''}>${r}</option>`).join('')}
                                </select>
                            </div>
                        </div>
                        
                        <div class="mt-4 p-4 ${!canManageUsers ? 'bg-slate-50' : 'bg-white'} border border-slate-200 rounded-xl flex items-center justify-between shadow-sm">
                            <div>
                                <p class="font-bold ${!canManageUsers ? 'text-slate-400' : 'text-slate-700'} text-sm">Account aktiv</p>
                                <p class="text-[10px] text-slate-400 uppercase tracking-widest mt-0.5">Inaktive User können sich nicht loggen.</p>
                            </div>
                            <input type="checkbox" id="mem-active" ${(!isEditMode || existingUser?.isActive !== false) ? 'checked' : ''} ${!canManageUsers ? 'disabled class="w-5 h-5 rounded border-slate-200 cursor-not-allowed"' : 'class="w-5 h-5 text-blue-600 rounded border-slate-300"'}>
                        </div>
                    </div>

                    ${canManageUsers ? `
                    <details class="group bg-slate-50 border border-slate-200 rounded-[2rem] p-2">
                        <summary class="flex items-center justify-between p-4 cursor-pointer font-black text-slate-700 uppercase tracking-widest text-xs">
                            <span class="flex items-center gap-2"><i data-lucide="calendar" class="w-4 h-4 text-slate-400"></i> Limits & Kontingente</span>
                            <i data-lucide="chevron-down" class="w-4 h-4 text-slate-400 group-open:rotate-180 transition-transform"></i>
                        </summary>
                        <div class="p-4 pt-0 space-y-6">
                            <div id="limit-settings-section" class="border-t border-slate-100 pt-6 space-y-6">
                                <h4 class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-4">Homeoffice Limits</h4>
                                
                                <div class="bg-white p-4 rounded-2xl border border-slate-200">
                                    <label class="flex items-center gap-2 mb-3 cursor-pointer">
                                        <input type="checkbox" id="edit-weekly-hasLimit" class="rounded text-blue-600 focus:ring-blue-500" onchange="window.toggleLimitInputs('weekly')" ${existingUser?.limits?.weekly?.hasLimit ? 'checked' : ''}>
                                        <span class="text-sm font-bold text-slate-700">Wochen-Limit aktivieren</span>
                                    </label>
                                    
                                    <div id="weekly-inputs" class="${existingUser?.limits?.weekly?.hasLimit ? '' : 'hidden'} pl-6 flex flex-col gap-3">
                                        <div>
                                            <label class="text-xs font-bold text-slate-500">Max. Tage pro Woche:</label>
                                            <input type="number" id="edit-weekly-days" value="${existingUser?.limits?.weekly?.days || ''}" class="w-20 p-2 rounded-lg border border-slate-200 text-sm mt-1 outline-none focus:border-blue-500" min="1" max="7">
                                        </div>
                                        <label class="flex items-center gap-2 cursor-pointer mt-2">
                                            <input type="checkbox" id="edit-weekly-isStrict" class="rounded text-orange-500 focus:ring-orange-500" ${existingUser?.limits?.weekly?.isStrict ? 'checked' : ''}>
                                            <span class="text-xs font-bold text-orange-600">Striktes Limit (Blockiert Buchung)</span>
                                        </label>
                                    </div>
                                </div>

                                <div class="bg-white p-4 rounded-2xl border border-slate-200">
                                    <label class="flex items-center gap-2 mb-3 cursor-pointer">
                                        <input type="checkbox" id="edit-monthly-hasLimit" class="rounded text-blue-600 focus:ring-blue-500" onchange="window.toggleLimitInputs('monthly')" ${existingUser?.limits?.monthly?.hasLimit ? 'checked' : ''}>
                                        <span class="text-sm font-bold text-slate-700">Monats-Limit aktivieren</span>
                                    </label>
                                    
                                    <div id="monthly-inputs" class="${existingUser?.limits?.monthly?.hasLimit ? '' : 'hidden'} pl-6 flex flex-col gap-3">
                                        <div>
                                            <label class="text-xs font-bold text-slate-500">Max. Tage pro Monat:</label>
                                            <input type="number" id="edit-monthly-days" value="${existingUser?.limits?.monthly?.days || ''}" class="w-20 p-2 rounded-lg border border-slate-200 text-sm mt-1 outline-none focus:border-blue-500" min="1" max="31">
                                        </div>
                                        <label class="flex items-center gap-2 cursor-pointer mt-2">
                                            <input type="checkbox" id="edit-monthly-isStrict" class="rounded text-orange-500 focus:ring-orange-500" ${existingUser?.limits?.monthly?.isStrict ? 'checked' : ''}>
                                            <span class="text-xs font-bold text-orange-600">Striktes Limit (Blockiert Buchung)</span>
                                        </label>
                                    </div>
                                </div>

                                <div id="vacation-settings-section" class="border-t border-slate-100 pt-6">
                                    <h4 class="text-[10px] font-black text-emerald-600 uppercase tracking-widest mb-4">Urlaubs-Konfiguration</h4>
                                    <div class="bg-emerald-50/50 p-5 rounded-3xl border border-emerald-100">
                                        <div class="grid grid-cols-2 gap-4">
                                            <div>
                                                <label class="block text-[10px] font-black text-emerald-700 uppercase tracking-widest mb-2 ml-1">Jahresanspruch (Tage)</label>
                                                <input type="number" id="edit-vacation-total" value="${existingUser?.limits?.vacation?.total || 30}" 
                                                    class="w-full bg-white border border-emerald-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-emerald-500 shadow-sm" min="0">
                                            </div>
                                            <div>
                                               <label class="block text-[10px] font-black text-emerald-700 uppercase tracking-widest mb-2 ml-1">Regel-Typ</label>
                                                    <select id="edit-vacation-type" class="w-full bg-white border border-emerald-200 rounded-xl px-4 py-3 font-bold text-slate-700 outline-none focus:border-emerald-500 shadow-sm">
                                                      <option value="none" ${existingUser?.limits?.vacation?.type === 'none' ? 'selected' : ''}>Keine Regel (Sofort gültig)</option>
                                                     <option value="soft" ${existingUser?.limits?.vacation?.type === 'soft' ? 'selected' : ''}>Weich (Vertreter-Pflicht)</option>
                                                      <option value="hard" ${existingUser?.limits?.vacation?.type === 'hard' ? 'selected' : ''}>Hart (Genehmigungs-Pflicht)</option>
                                                    </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </details>
                    ` : ''}

                </div>

                <div class="p-6 md:p-8 border-t border-slate-100 flex gap-4 shrink-0 bg-white rounded-b-[2.5rem]">
                    <button onclick="window.submitMemberForm('${editUserId || ''}')" class="flex-1 ${isEditMode ? 'bg-emerald-600 hover:bg-emerald-700 shadow-emerald-100' : 'bg-blue-600 hover:bg-blue-700 shadow-blue-100'} text-white py-4 rounded-2xl font-black uppercase text-xs tracking-widest transition-all shadow-xl">
                        ${isEditMode ? 'Änderungen speichern' : 'Profil anlegen'}
                    </button>
                    <button onclick="document.getElementById('member-modal').remove()" class="px-8 py-4 bg-slate-100 text-slate-600 font-bold uppercase text-xs tracking-widest rounded-2xl hover:bg-slate-200 transition-all">
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    `;

    let modalContainer = document.getElementById('member-modal-container');
    if (!modalContainer) {
        modalContainer = document.createElement('div');
        modalContainer.id = 'member-modal-container';
        document.body.appendChild(modalContainer);
    }
    modalContainer.innerHTML = modalHTML;
    if (window.lucide) lucide.createIcons();
};

window.submitMemberForm = async function(editUserId) {
    const isEditMode = editUserId !== '';
    const u = window.currentUser;
    const canManageUsers = ['OWNER', 'ADMIN', 'HR', 'SUPERADMIN'].includes(u?.role);
    
    // 1. Formulardaten sammeln
    const formStreet = document.getElementById('mem-street')?.value.trim() || '';
    const formHouse = document.getElementById('mem-house')?.value.trim() || '';
    const formZip = document.getElementById('mem-zip')?.value.trim() || '';
    const formCity = document.getElementById('mem-city')?.value.trim() || '';

    // Basis-Datenobjekt erstellen
    let userData = {
        salutation: document.getElementById('mem-salutation')?.value || '',
        firstName: document.getElementById('mem-first')?.value.trim() || '',
        lastName: document.getElementById('mem-last')?.value.trim() || '',
        street: formStreet,
        houseNumber: formHouse,
        zip: formZip,
        city: formCity,
        address: {
            street: formStreet,
            houseNumber: formHouse,
            zip: formZip,
            city: formCity,
            country: 'Deutschland'
        }
    };

    // 2. Admin-Felder hinzufügen
    if (canManageUsers) {
        userData.nodeId = document.getElementById('mem-nodeId')?.value || '';
        userData.reportsTo = document.getElementById('mem-reportsTo')?.value || '';
        userData.role = document.getElementById('mem-role')?.value || 'EMPLOYEE';
        userData.isActive = document.getElementById('mem-active')?.checked !== false;

        if (document.getElementById('limit-settings-section')) {
            userData.limits = {
                weekly: {
                    hasLimit: document.getElementById('edit-weekly-hasLimit')?.checked || false,
                    days: parseInt(document.getElementById('edit-weekly-days')?.value) || 0,
                    isStrict: document.getElementById('edit-weekly-isStrict')?.checked || false
                },
                monthly: {
                    hasLimit: document.getElementById('edit-monthly-hasLimit')?.checked || false,
                    days: parseInt(document.getElementById('edit-monthly-days')?.value) || 0,
                    isStrict: document.getElementById('edit-monthly-isStrict')?.checked || false
                },
                vacation: {
                    total: parseInt(document.getElementById('edit-vacation-total')?.value) || 0,
                    type: document.getElementById('edit-vacation-type')?.value || 'soft'
                }
            };
        }
    }

    // 3. Validierung & Modus-Spezifische Daten
    if (isEditMode) {
        userData.updatedAt = new Date();
    } else {
        userData.email = document.getElementById('mem-email')?.value.trim() || '';
        userData.password = document.getElementById('mem-password')?.value.trim() || ''; 
        userData.companyId = u.companyId; 
        userData.createdAt = new Date();

        if (!userData.email || !userData.password) {
            window.showToast("Bitte E-Mail und Passwort angeben.", true);
            return;
        }
    }

    if (!userData.firstName || !userData.lastName) {
        window.showToast("Vor- und Nachname sind Pflichtfelder.", true);
        return;
    }

    // 4. SPEICHERN
    try {
        if (isEditMode) {
            // Beim Bearbeiten nutzen wir das bestehende Cloud-Update
            await window.updateUserInCloud(editUserId, userData);
            window.showToast("Profil erfolgreich aktualisiert!");
        } else {
            // BEIM NEUANLEGEN: Aufruf unserer neuen sicheren Backend-Funktion
            // Wir übergeben das saubere userData Objekt
            await window.createNewUserInDB(userData);
            window.showToast("Neuer Mitarbeiter wurde sicher im Backend angelegt! 🎉");
        }

        // Modal schließen und Daten neu laden
        const modal = document.getElementById('member-modal');
        if (modal) modal.remove();
        
        if (typeof window.loadInitialData === 'function') {
            await window.loadInitialData();
        }
        
    } catch (e) {
        console.error("Fehler im Member-Formular:", e);
        // Hier fangen wir den Fehler ab, falls das Backend z.B. meldet, dass die E-Mail schon existiert
        window.showToast("Fehler: " + (e.message || "Unbekannter Fehler"), true);
    }
};

window.toggleLimitInputs = function(type) {
    const hasLimit = document.getElementById(`edit-${type}-hasLimit`)?.checked;
    const inputContainer = document.getElementById(`${type}-inputs`);
    if (inputContainer) {
        if (hasLimit) inputContainer.classList.remove('hidden');
        else inputContainer.classList.add('hidden');
    }
};